<template>
    <form class="row g-3" ref="form">
        <div class="col-12 col-md-6">
            <label for="name" class="form-label fw-bold">{{ $t("patrolRoute.name") }}</label>
            <input type="text" class="form-control" id="name" v-model="localPatrolRoute.name" required>
        </div>
        <div class="col-12 col-md-6">
            <label for="frequency" class="form-label fw-bold">{{ $t("patrolRoute.frequencyMinutes") }}</label>
            <input type="text" class="form-control" id="frequency" v-model="localPatrolRoute.frequency">
        </div>
        <div class="col-12 col-md-6">
            <label for="startedAt" class="form-label fw-bold">{{ $t("patrolRoute.startedAt") }}</label>
            <input type="time" class="form-control" id="startedAt" v-model="localPatrolRoute.startedAt">
        </div>
        <div class="col-12 col-md-6">
            <label for="finishedAt" class="form-label fw-bold">{{ $t("patrolRoute.finishedAt") }}</label>
            <input type="time" class="form-control" id="finishedAt" v-model="localPatrolRoute.finishedAt">
        </div>
    </form>
</template>

<script>
export default {
    emits: ["submit"],
    props: {
        patrolRoute: {
            type: Object,
            default: () => ({}),
        }
    },
    data() {
        return {
            localPatrolRoute: {...this.patrolRoute}
        }
    },
    methods: {
        validateData() {
                if (this.$refs.form.checkValidity() === false){
                    this.$refs.form.reportValidity();
                    return false;
                }
                return true;
            },
            submitForm() {
                if (!this.validateData()) return;
                    this.$emit("submit", this.localPatrolRoute)
            },
    },
    watch: {
        patrolRoute: {
            handler(newVal) {
                this.localPatrolRoute = {
                    name: newVal.name || "",
                    frequency: newVal.frequency_minutes || "",
                    startedAt: newVal.started_at || "",
                    finishedAt: newVal.finished_at || "",
                };
            },
            immediate: true,
        }
    }
}
</script>